/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from 'react';
import BreadCrumb from '../../common/components/BreadCrumb';
import {Row, Col, Button, Form} from 'react-bootstrap';

import TextHoverDisplay from "../../common/components/TextHoverDisplay";

import './AdminActionListContainer.scss';

import {
    getAdminListById,
    matchList
} from "./adminListSlice";


import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import FormSearchMatchTemplateTypeahead from "../components/match-templates/FormSearchMatchTemplateTypeahead";
import PanelHeader from "../../common/components/layout/PanelHeader";
import Panel from "../../common/components/layout/Panel";
import FormContainer from "../../common/components/layout/FormContainer";

const AdminMatchContainer = (props) => {
    const { id } = useParams();
    const adminListState = useSelector(state => state.adminList);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [breadcrumbItems, setBreadcrumbItems] = useState([]);
    const [managedList, setManagedList] = useState(null);

    useEffect(() => {
        dispatch(getAdminListById(id));
    }, [id, dispatch]);

    useEffect(() => {
        if (adminListState.adminList && adminListState.adminList.id === id) {
            setManagedList(adminListState.adminList);
            setBreadcrumbItems(
                [
                    {label: 'Home', href: '/home', isActive: false},
                    {
                        label: 'Lists',
                        href: '/admin/lists',
                        isActive: false
                    },
                    {
                        label: `${id}`,
                        href: '',
                        isActive: true
                    },
                    {
                        label: 'Match List',
                        href: '',
                        isActive: true
                    }
                 ]
            )
        }
        }
        , [adminListState.adminList]);

    useEffect(() => {
        setAlertMessage(adminListState.alertMessage);
        if (adminListState.alertMessage) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    }, [adminListState.alertMessage]);

    useEffect(() => {
        setSuccessMessage(adminListState.successMessage);
        if (adminListState.successMessage) {
            setShowSuccess(true);
            navigate('/admin/lists');
        }else {
            setShowSuccess(false);
        }
    }, [adminListState.successMessage]);

    const handleAdminMatch = async (data) => {
        dispatch(matchList({id: id, matchTemplateId: data.matchTemplate[0].id}));
    };

    const handleCancel = async () => {
        navigate('/admin/lists')
    };

    return (
        <div>
            {adminListState.loading && (
                <div className="spinner-overlay">
                    <Spinner
                        as="span"
                        animation="border"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="info"
                    />
                </div>
            )}
            <Alert
                variant={"danger"}
                show={showAlert}
                onClose={() => setShowAlert(!showAlert)}
                dismissible
                transition={false}
            >
                {alertMessage}
            </Alert>
            <Alert
                variant={"success"}
                show={showSuccess}
                onClose={() => setShowSuccess(!showSuccess)}
                dismissible
                transition={false}
            >
                {successMessage}
            </Alert>
            <AdminMatch
                id={managedList?.id}
                name={managedList?.name}
                handleAdminMatch={(data) => handleAdminMatch(data)}
                handleCancel={() => handleCancel()}
                status={managedList?.status}
                type={managedList?.type}
                breadcrumbItems={breadcrumbItems}
            />
        </div>
    );
};


function AdminMatch(props) {

    const {
        breadcrumbItems,
        id,
        name,
        status,
        type,
        handleAdminMatch,
        handleCancel,
    } = props;

    // Form
    const [formValid, setFormValid] = useState(true);
    const [matchTemplate, setMatchTemplate] = useState([]);

    const reset = () => {

    };

    const isValid = () => {
        if (!matchTemplate) return false;
        return true;
    };

    const handleAdminMatchClick = async () => {
        if (!isValid()) {
            setFormValid(false);
        } else {
            handleAdminMatch({id, matchTemplate});
        }
    };

    return (
        <div className="action-list-gutter">
            <BreadCrumb items={breadcrumbItems}> </BreadCrumb>
            <PanelHeader header={`Match List - ${name ? name : ''}`} subHeader={'Match the list'} />
            <Panel>
                <FormContainer>
                    <Form noValidate>
                        <Form.Group controlId="matchList">
                            <Row>
                                <Col md={6}>
                                    <Row>
                                        <Col md={9} className="action-list-form-label">
                                            <Form.Label>List Id</Form.Label>
                                            {id &&
                                                <TextHoverDisplay
                                                    fullText={id}
                                                    truncatedText={id}
                                                    displayTruncated={false}
                                                />
                                            }

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={name}
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <Form.Label>Type</Form.Label>
                                            <Form.Control
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={type}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={9} className="create-input-form-label">
                                            <Form.Label>Status</Form.Label>
                                            <Form.Control
                                                as="input"
                                                size="sm"
                                                disabled
                                                value={status}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <FormSearchMatchTemplateTypeahead
                                                label={'Match Template Id'}
                                                onChange={setMatchTemplate}
                                                matchTemplate={matchTemplate}
                                                isInvalid={!formValid && matchTemplate.length === 0}
                                                editing
                                                required
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="buttons">
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        variant="info"
                                        onClick={() => handleAdminMatchClick()}
                                    >MATCH
                                    </Button>
                                    <Button
                                        className="btn-min-width-120 btn-height-35"
                                        style={{marginLeft: "10px"}}
                                        variant="outline-secondary"
                                        onClick={() => {
                                            reset();
                                            handleCancel();
                                        }}
                                    >CANCEL
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Group>
                    </Form>
                </FormContainer>
            </Panel>
        </div>
    );
}

export default AdminMatchContainer;

